import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import { Tabs, Pane } from '../../shared/tabs';
import MainForm from '../components/forms/general/main';
import LandingForm from '../components/forms/landings/main';
import TargetingFrom from '../components/forms/targeting/main';
import PromoForm from '../components/forms/promo/main';
import IndividualTermsForm from '../components/forms/individual-terms/main';
import RestrictedGeoForm from '../components/forms/restricted-geo/main';

import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(props => {
	return (
		<Animate>
			<div className="container__content programs-editor">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Link to='programs/' className="link">{ props.intl('Return to list of programs') }</Link>
					</div>
					<div className="container__content-title-position">
						<h1 className="title">{ props.intl('Offer editor') }</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className='form-container everad_offers-editor'>
						<div className="form-container__head">
							<h2 className="title icon-edit">{ props.intl('Offer editor') }</h2>
							{ props.data.title && (
								<span className="item-title">{props.data.title}</span>
							)}
						</div>
						<Tabs selected={props.currentTab} onTabChange={props.tabChange}>
							<Pane label={ props.intl('Main') } index="main">
								<MainForm
									{...props}
									initialValues={props.mainFormData.initialValues}
									payoutCurrencies={props.payoutCurrencies}
									enableReinitialize={true}/>
							</Pane>
							<Pane label={ props.intl('Landings') } index="landings" isVisible={!!props.data.id}>
								<LandingForm
									{...props}
									initialValues={props.landingsFormData.initialValues}
									enableReinitialize={true}/>
							</Pane>
							<Pane label={ props.intl('Targeting') } index="targeting" isVisible={!!props.data.id}>
								<TargetingFrom
									{...props}
									initialValues={props.targetingFormData.initialValues}
									activeCheckboxStates={props.targetingActiveCheckboxStates}
									enableReinitialize={true}/>
							</Pane>
							<Pane
								label={ props.intl('Individual terms') }
								index='individual-terms'
								isVisible={
									props.can('grantOffers') &&
									!!props.data.id && Array.isArray(props.targeting) && props.targeting.length > 0
								}>
								<IndividualTermsForm
									{...props}
									initialValues={props.individualTermsFormData.initialValues}
									formData={props.individualTermsFormData}
									enableReinitialize={true}/>
							</Pane>
							<Pane label={props.intl('Restricted geo')} index="restricted-geo" isVisible={!!props.data.id}>
								<RestrictedGeoForm
									{...props}
									enableReinitialize={true}
									initialValues={props.restrictedGeoFormData.initialValues}/>
							</Pane>
							<Pane label={ props.intl('Promo') } index="promo" isVisible={!!props.data.id}>
								<PromoForm {...props} />
							</Pane>
						</Tabs>
					</div>
				</div>
			</div>
		</Animate>
	);
}, 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		targeting: selectors.getTargeting(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		mainTabLangs: selectors.getMainTabLangs(state),
		landingsTabLangs: selectors.getLandingsTabLangs(state),
		restrictedGeoTabLangs: selectors.getRestrictedGeoTabLangs(state),
		mainFormData: selectors.getMainFormData(state),
		landingsFormData: selectors.getLandingsFormData(state),
		targetingFormData: selectors.getTargetingFormData(state),
		activePayoutCurrencies: selectors.getActivePayoutCurrencies(state),
		targetingActiveCheckboxStates: selectors.getTargetingActiveCheckboxStates(state),
		individualTermsFormData: selectors.getIndividualTermsFormData(state),
		restrictedGeoFormData: selectors.getRestrictedGeoFormData(state),
		promoData: selectors.getPromoData(state),
		payoutCurrencies: selectors.getPayoutCurrencies(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		currentTab: selectors.getCurrentTab(state),
		error: selectors.getError(state),
		admin: selectors.getAdminData(state),
		deleteLandingModal: selectors.getDeleteLandingModal(state),
		landingsFilters: selectors.getLandingsFilters(state),
		individualTermsFilters: selectors.getIndividualTermsFilters(state)
	}),
	mapDispatchToProps,
	mergeProps
)(Main);

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions, dispatch),
		landingsFilters: bindActionCreators(actions.landingsFiltersActions, dispatch),
		individualTermsFilters: bindActionCreators(actions.individualTermsFiltersActions, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		landingsFilters: {
			...stateProps.landingsFilters,
			...dispatchProps.landingsFilters
		},
		individualTermsFilters: {
			...stateProps.individualTermsFilters,
			...dispatchProps.individualTermsFilters
		}
	};
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/editor/main.js